import { ILayerColumn, ITableColumn, MapCoreDocument } from '../../../types';
import { IBaseNode, NodeType } from '../IBaseNode';

export class ECSNode implements IBaseNode {
    public asc = false;
    public enabled = true;
    public columns: (ILayerColumn | ITableColumn)[];
    public orderBy = '';
    public record: MapCoreDocument;

    public name: string;
    public description: string;

    public constructor(document?: MapCoreDocument) {
        if (document) {
            this.name = document.title;
            this.description = document.description;
            this.record = document;
        }
    }

    public get nodeType(): NodeType {
        if (this.record) {
            return NodeType.Document;
        } else {
            return NodeType.Category;
        }
    }
}
